/**
 * Canonical compatibility issue code identifiers.
 * Kept separate so the policy registry can import codes without cycling through
 * enforcement / buildCanonicalIssue helpers.
 */

export const COMPATIBILITY_CODES = {
  REPORT_TEMPLATE_TYPE_MISMATCH: 'report_template_type_mismatch',
  EMAIL_WRAPPER_TYPE_MISMATCH: 'email_wrapper_type_mismatch',
  SMS_WRAPPER_TYPE_MISMATCH: 'sms_wrapper_type_mismatch',
  WORKFLOW_SMS_UNSUPPORTED: 'workflow_sms_unsupported',
  DEPRECATED_REPORT_TYPE: 'deprecated_report_type',
  MISSING_EFFECTIVE_REPORT_TYPE: 'missing_effective_report_type',
  UNRESOLVED_EFFECTIVE_WORKFLOW: 'unresolved_effective_workflow',
  HISTORICAL_INCOMPATIBLE_SELECTION: 'historical_incompatible_selection',
  INCOMPLETE_EVALUATION: 'incomplete_evaluation',
  TEMPLATE_INACTIVE: 'template_inactive',
  TEMPLATE_NOT_FOUND: 'template_not_found',
  UNSUPPORTED_REPORT_CAPABILITY: 'unsupported_report_capability',
} as const;

export type CompatibilityCode = (typeof COMPATIBILITY_CODES)[keyof typeof COMPATIBILITY_CODES];

export const COMPATIBILITY_CODE_LIST: CompatibilityCode[] = Object.values(COMPATIBILITY_CODES);

export function isCompatibilityCode(value: string): value is CompatibilityCode {
  return (COMPATIBILITY_CODE_LIST as string[]).includes(value);
}
